import { format } from "date-fns";
import { Link } from "react-router-dom";
import config from "./config";
export default function Post({
  _id,
  title,
  summary,
  content,
  path_cover,
  author,
  createdAt,
  isCompact = false,
}) {
  return (
    <div className={`post ${isCompact ? "compact" : ""}`}>
      <div className="image">
        <Link to={`/post/${_id}`}>
          <img src={`${config.apiUrl}/${path_cover}`} alt="PostPicture" />
        </Link>
      </div>
      <div className="texts">
        <Link to={`/post/${_id}`}>
          <h1>{title}</h1>
        </Link>
        <p className="info">
          <time>{format(new Date(createdAt), "dd MMM yyyy HH:mm")}</time>
          <span className="author"> by {author.username} </span>
        </p>
        {!isCompact && <p className="summary">{summary}</p>}
      </div>
    </div>
  );
}
